import {Currency} from "@pg-rp/common-types";

import {ISearchInputValue} from "../components/ISearchInputValue";
import {floorChoices} from "../constants/filter_slot_presets/floor_choices";
import {houseAdditionalAreas} from "../constants/filter_slot_presets/house_additional_areas";
import {houseStoreys} from "../constants/filter_slot_presets/house_storeys";
import {houseType} from "../constants/filter_slot_presets/house_type";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {SearchTab} from "../types/SearchTab";
import {formatRecentFilterText} from "./format_recent_filter_text";
import {getSearchTerm} from "./get_search_term";
import {stringifySearchFormType} from "./stringify_search_form_type";

export const getAmplitudeSearchQuery = (search: ISearchInputValue | undefined, filters?: Partial<ISearchFiltersFormValues>): string => {
    if (!search || search.tabType !== SearchTab.Regions) {
        return search ? getSearchTerm(search) : "";
    }

    const basePart = formatRecentFilterText({filters: filters ?? {}, search, currency: Currency.PLN});

    const extraParts = [
        stringifySearchFormType(filters?.type ?? []),
        mapValuesToLabels(filters?.floor_choices, floorChoices.filters?.[0]?.filterOptions),
        mapValuesToLabels(filters?.house_type, houseType.filters?.[0]?.filterOptions),
        mapValuesToLabels(filters?.house_additional_areas, houseAdditionalAreas.filters?.[0]?.filterOptions),
        mapValuesToLabels(filters?.house_storeys, houseStoreys.filters?.[0]?.filterOptions)
    ].filter(Boolean) as string[];

    const allParts = [basePart, ...extraParts].filter(Boolean);
    return allParts.join(", ") || getSearchTerm(search);
};

const mapValuesToLabels = (values: string[] | number[] | undefined, options: {value: string; label: string}[]): string | null => {
    if (!values?.length) {
        return null;
    }

    const labels = (values as (string | number)[])
        .map((filterValue) => options.find((option) => option.value === filterValue.toString())?.label)
        .filter(Boolean) as string[];

    return labels.length ? labels.join(", ") : null;
};
import {Currency} from "@pg-rp/common-types";

import {ISearchInputValue} from "../components/ISearchInputValue";
import {floorChoices} from "../constants/filter_slot_presets/floor_choices";
import {houseAdditionalAreas} from "../constants/filter_slot_presets/house_additional_areas";
import {houseStoreys} from "../constants/filter_slot_presets/house_storeys";
import {houseType} from "../constants/filter_slot_presets/house_type";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {SearchTab} from "../types/SearchTab";
import {formatRecentFilterText} from "./format_recent_filter_text";
import {getSearchTerm} from "./get_search_term";
import {stringifySearchFormType} from "./stringify_search_form_type";

export const getAmplitudeSearchQuery = (search: ISearchInputValue | undefined, filters?: Partial<ISearchFiltersFormValues>): string => {
    if (!search || search.tabType !== SearchTab.Regions) {
        return search ? getSearchTerm(search) : "";
    }

    const basePart = formatRecentFilterText({filters: filters ?? {}, search, currency: Currency.PLN});

    const extraParts = [
        stringifySearchFormType(filters?.type ?? []),
        mapValuesToLabels(filters?.floor_choices, floorChoices.filters?.[0]?.filterOptions),
        mapValuesToLabels(filters?.house_type, houseType.filters?.[0]?.filterOptions),
        mapValuesToLabels(filters?.house_additional_areas, houseAdditionalAreas.filters?.[0]?.filterOptions),
        mapValuesToLabels(filters?.house_storeys, houseStoreys.filters?.[0]?.filterOptions)
    ].filter(Boolean) as string[];

    const allParts = [basePart, ...extraParts].filter(Boolean);
    return allParts.join(", ") || getSearchTerm(search);
};

const mapValuesToLabels = (values: string[] | number[] | undefined, options: {value: string; label: string}[]): string | null => {
    if (!values?.length) {
        return null;
    }

    const labels = (values as (string | number)[])
        .map((filterValue) => options.find((option) => option.value === filterValue.toString())?.label)
        .filter(Boolean) as string[];

    return labels.length ? labels.join(", ") : null;
};
